import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { VirtualsIcon } from 'src/domains/layouts/shared/assets/icons/VirtualsIcon';
import { InPlayIcon } from 'src/domains/layouts/shared/assets/icons/InPlayIcon';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import styled from '@emotion/styled';
import { StatsIcon } from 'src/domains/layouts/shared/assets/icons/StatsIcon';
import { CasinoTableGamesIcon } from 'src/domains/layouts/shared/assets/icons/CasinoTableGamesIcon';
import { NewsIcon } from 'src/domains/layouts/shared/assets/icons/NewsIcon';
import { CasinoLucky6Icon } from 'src/domains/layouts/shared/assets/icons/CasinoLucky6Icon';
import { CasinoIcon } from 'src/domains/layouts/shared/assets/icons/CasinoIcon';
import { css, SerializedStyles } from '@emotion/react';
import { withConfig } from 'src/withConfig';
import { FootballIcon as BestOddsFootballIconRaw } from 'src/domains/layouts/shared/assets/icons/bestodds/sports/FootballIcon';
import { InPlayIcon as BestOddsInPlayIcon } from 'src/domains/layouts/shared/assets/icons/bestodds/sports/InPlayIcon';
import { CardsIcon as BestOddsCardsIcon } from 'src/domains/layouts/shared/assets/icons/bestodds/casino/CardsIcon';
import { ChipIcon as BestOddsChipIcon } from 'src/domains/layouts/shared/assets/icons/bestodds/casino/ChipIcon';
import { VirtualsIcon as BestOddsVirtualsIcon } from 'src/domains/layouts/shared/assets/icons/bestodds/casino/VirtualsIcon';
import { NavigationVariantType } from 'src/domains/layouts/config/features/types';
import { HorseRacingIcon } from 'src/domains/layouts/shared/assets/icons/bestodds/sports/HorseRacingIcon';
import { SportsIcon as BestOddsSportsIconRaw } from 'src/domains/layouts/shared/assets/icons/bestodds/sports/SportsIcon';
import { FootballIcon } from 'src/ui/assets/icons/sports/FootballIcon';

interface HeaderMainLinksPropsType {
    source?: string;
    isActive: boolean;
    variant: NavigationVariantType | null;
}

interface HeaderMainLinkPropsType {
    isSpecialLink: boolean;
    isLargeDesktop: boolean;
    isHamburgerMenuOpen?: boolean;
}

export const HeaderMainLinkWrapper = withConfig(theme => styled('nav', { label: 'HeaderMainLinkWrapper' }) <HeaderMainLinkPropsType>`
    background-color: ${theme.star.headerMain.bgColorQuaternary};
    padding: ${({ isSpecialLink }): string => isSpecialLink ? '8px 0 16px' : '0 0 16px'};
    display: ${({ isHamburgerMenuOpen }): string => isHamburgerMenuOpen === true ? 'block' : 'none'};
    @media ${theme.star.mediaQuery.largeDesktop} {
        background-color: ${theme.star.headerMain.bgColor};
        align-items: center;
        display: flex;
        height: 100%;
        overflow: hidden;
        padding: 0;
    }
`);


const setLink = (variant: NavigationVariantType | null,theme: EmotionTheme, isActive?: boolean): SerializedStyles => {
    return css`
        align-items: center;
        cursor: pointer;
        display: flex;
        font-size: ${variant === NavigationVariantType.SECONDARY ? theme.star.fontSize.xRegular : theme.star.fontSize.regular};
        font-weight: ${theme.star.fontWeight.bold};
        line-height: 1.5;
        padding: 8px 16px;
        text-decoration: none;
        text-transform: uppercase;
        transition: color .2s ease;
        color: ${isActive === true ? theme.star.headerMain.txtColorSecondary : theme.star.headerMain.txtColorTertiary};
        svg {
            transition: fill .2s ease;
        }
        &:hover {
            color: ${theme.star.headerMain.txtColorSecondary};
        }
        @media ${theme.star.mediaQuery.largeDesktop} {
            color: ${isActive === true ? theme.star.headerMain.txtColorSecondary : theme.star.headerMain.txtColor};
            flex-flow: row nowrap;
            white-space: nowrap;
            padding: 0 8px;
        }
    `;
};

export const HeaderStyledLink = withConfig(theme => styled(Link, { label: 'HeaderStyledLink' })<HeaderMainLinksPropsType>`
    ${({ isActive, variant }): SerializedStyles => setLink(variant, theme, isActive)};
`);

interface HeaderStyledPropsType {
    variant: NavigationVariantType | null;
}


export const HeaderStyledStaticLink = withConfig(theme => styled(Link, { label: 'HeaderStyledStaticLink' })<HeaderStyledPropsType>`
    ${({ variant }): SerializedStyles => setLink(variant, theme)};
`);

export const HeaderStyledStaticOnClick = withConfig(theme => styled('button', { label: 'HeaderStyledStaticOnClick' })<HeaderStyledPropsType>`
    ${({ variant }): SerializedStyles => setLink(variant, theme)};
    background: none;
    border: none;
    cursor: pointer;
`);

const setIconInMenu = (): SerializedStyles => {
    return css`
        fill: currentcolor;
        flex: 0 0 16px;
        margin: 0 8px 0 0;
        height: 16px;
        width: 16px;
    `;
};

interface HeaderIconsPropsType {
    source?: string;
}

export const SpecialsIconWrapper = styled('div', { label: 'SpecialsIconWrapper' }) <HeaderIconsPropsType>`
    ${(): SerializedStyles => setIconInMenu()};
    background: currentcolor;
    ${({ source }): string => source === undefined ? '' : `mask: url(${source}) no-repeat center`};
    mask-size: contain;
`;

export const DefaultCasinoIcon = styled(CasinoIcon, { label: 'DefaultCasinoIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
`;

export const DefaultSportsIcon = styled(FootballIcon, { label: 'DefaultSportsIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
`;
export const StatsIconWrapper = styled(StatsIcon, { label: 'StatsIconWrapper' })`
    ${(): SerializedStyles => setIconInMenu()};
`;

export const DefaultInPlayIcon = styled(InPlayIcon, { label: 'DefaultInPlayIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
`;

export const DefaultVirtualsIcon = styled(VirtualsIcon, { label: 'DefaultVirtualsIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
`;

export const NewsIconWrapper = styled(NewsIcon, { label: 'NewsIconWrapper' })`
    ${setIconInMenu()};
`;

export const DefaultLiveCasinoIcon = styled(CasinoTableGamesIcon, { label: 'DefaultLiveCasinoIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
`;

export const BingoIconWrapper = styled(CasinoLucky6Icon, { label: 'BingoIconWrapper' })`
    ${(): SerializedStyles => setIconInMenu()};
`;

const bestOddsIconStyle : SerializedStyles = css`
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
`;

export const BestOddsSportsIcon = styled(BestOddsSportsIconRaw, { label: 'BestOddsSportsIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
    ${bestOddsIconStyle}
`;

export const BestOddsFootballIcon = styled(BestOddsFootballIconRaw, { label: 'BestOddsFootballIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
    ${bestOddsIconStyle}
`;

export const BestOddsHorseRacingIcon = styled(HorseRacingIcon, { label: 'BestOddsHorseRacingIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
    ${bestOddsIconStyle}
`;

export const BestOddsFooterInPlayIcon = styled(BestOddsInPlayIcon, { label: 'BestOddsFooterInPlayIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
    ${bestOddsIconStyle}
`;

export const BestOddsCasinoIcon = styled(BestOddsCardsIcon, { label: 'BestOddsCasinoIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
    ${bestOddsIconStyle}
`;

export const BestOddsLiveCasinoIcon = styled(BestOddsChipIcon, { label: 'BestOddsLiveCasinoIcon' })`
    ${(): SerializedStyles => setIconInMenu()};
    ${bestOddsIconStyle}
`;

export const BestOddsVirtualsIconWrapper = styled(BestOddsVirtualsIcon, { label: 'BestOddsVirtualsIconWrapper' })`
    ${(): SerializedStyles => setIconInMenu()};
    ${bestOddsIconStyle}
`;
